export const COLS = 10;
export const ROWS = 16;

/** @typedef {{ note: string, color: string }} BoardCell */

export class Board {
  constructor(cols = COLS, rows = ROWS) {
    this.cols = cols;
    this.rows = rows;
    /** @type {(BoardCell|null)[][]} */
    this.grid = Array.from({ length: rows }, () => Array(cols).fill(null));
  }

  reset() {
    this.grid = Array.from({ length: this.rows }, () => Array(this.cols).fill(null));
  }

  inBounds(x, y) {
    return x >= 0 && x < this.cols && y >= 0 && y < this.rows;
  }

  isEmpty(x, y) {
    return this.inBounds(x, y) && this.grid[y][x] === null;
  }

  /** @param {import('./piece.js').Piece} piece */
  collides(piece, offsetX = 0, offsetY = 0) {
    for (const block of piece.blocks()) {
      const x = block.x + offsetX;
      const y = block.y + offsetY;
      if (x < 0 || x >= this.cols || y >= this.rows) return true;
      if (y >= 0 && this.grid[y][x] !== null) return true;
    }
    return false;
  }

  /** @param {import('./piece.js').Piece} piece */
  lock(piece) {
    for (const block of piece.blocks()) {
      const { x, y, note, color } = block;
      if (y >= 0 && y < this.rows && x >= 0 && x < this.cols) {
        this.grid[y][x] = { note, color };
      }
    }
  }

  /**
   * Elimina celdas marcadas y aplica gravedad estilo Puyo (columna a columna).
   * @param {Set<string>} keys — formato "x,y"
   */
  clearCells(keys) {
    for (const key of keys) {
      const [xs, ys] = key.split(',');
      const x = Number(xs);
      const y = Number(ys);
      if (this.inBounds(x, y)) this.grid[y][x] = null;
    }
    this.applyGravity();
  }

  applyGravity() {
    for (let x = 0; x < this.cols; x++) {
      let writeRow = this.rows - 1;
      for (let y = this.rows - 1; y >= 0; y--) {
        const cell = this.grid[y][x];
        if (cell) {
          if (writeRow !== y) {
            this.grid[writeRow][x] = cell;
            this.grid[y][x] = null;
          }
          writeRow--;
        }
      }
    }
  }

  isTopBlocked() {
    for (let x = 0; x < this.cols; x++) {
      if (this.grid[0][x] !== null) return true;
    }
    return false;
  }
}
